import styled, { css } from 'styled-components';

const withThemeStyles = (Component, componentName) => {
  return styled(Component)`
    ${({ theme }) => {
      return theme.widgets?.[componentName] || '';
    }}
  `;
};

const baseStyled = (component, componentName) => {
  return (strings, ...interpolations) => {
    const StyledComponent = styled(component)(strings, ...interpolations);
    return withThemeStyles(StyledComponent, componentName || 'Component');
  };
};

export { css };
export const styledClient = new Proxy(baseStyled, {
  get(target, property) {
    return target(property);
  },
  apply(target, thisArg, argumentsList) {
    return target(...argumentsList);
  }
});
